import { useNavigate } from "react-router-dom";
import { CardText, Envelope, Person, Phone, PinMap, TextParagraph } from "react-bootstrap-icons";
import { useContext, useState } from "react";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import { config } from "../../constants/config";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function AddClient() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [fetching, setFetching] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [tel1, setTel1] = useState("");
    const [tel2, setTel2] = useState("");
    const [adresse, setAdresse] = useState("");
    const [desc, setDesc] = useState("");
    const [type, setType] = useState('');
    const [typelist, setTypelist] = useState([]);
    const [abrev, setAbrev] = useState("");
    const [forme, setforme] = useState("");
    const [formelist, setformelist] = useState([]);
    const [logo, setLogo] = useState('');
    const [logoprev, setLogoprev] = useState('/assets/imgs/no-image.png');

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showWarningMessage = (msg) => {
        toast.warning(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccessMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        setLogo(file)
        TransformeLogo(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformeLogo = (file) => {
        const reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setLogoprev(reader.result);
            };
        } else {
            setLogoprev("/assets/imgs/no-image.png");
        }
    };

    const getTypesClient = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)typeclient

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=typeclient`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });

                        setTypelist(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            console.log("error get typeclient list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getFormes = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)
        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=formejuridique`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });

                        setformelist(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            console.log("error get formejuridique list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    // comportements
    useEffect(() => {
        getTypesClient();
        getFormes();
    }, [])

    const handleSubmit = async (e) => {

        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();

        urlencoded.append("nom", name);
        urlencoded.append("prenom", abrev);
        urlencoded.append("logo", logoprev);
        urlencoded.append("email", email);
        urlencoded.append("typeclient", type["value"]);
        urlencoded.append("tel1", tel1);
        if (tel2) urlencoded.append("tel2", tel2);
        urlencoded.append("adresse", adresse);
        urlencoded.append("descr", desc);
        if(forme) urlencoded.append("forme", forme["value"]);
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/customers`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        }  else {
                            setFetching(false);
                            showErrorMessage(data?.body?.data?.msg)
                        }
                    } else {
                        setFetching(false);
                        showSuccessMessage(textes.fr.oparationsuccess);
                        navigate(-1);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
            setFetching(false);
        });
    }


    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-4 font-weight-bold text_primary">Clients</h1>
            <div className="row">
                <div className="col-md-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quitter" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                <i className="fa fa-reply"></i> <span>Retour</span>
                            </button>
                            <h6 className="m-0 ">Informations du client</h6>
                        </div>
                        <div className="card-body">
                            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <div className="row">
                                            <div className="col-md-12 mb-2">
                                                <label htmlFor="logo" className="form-label">Logo du client</label>
                                                <input className="form-control" type="file" id="logo" onChange={handleLogoChange} />
                                            </div>
                                            <div className="col-md-12 mb-1">
                                                <img alt="" src={logoprev} className="rounded" style={{ width: "100%" }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8 mb-3">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="typeclient" className="mb-1">Type de client</label>
                                                <Select
                                                    id="typeclient"
                                                    name="typeclient"
                                                    options={typelist}
                                                    value={type}
                                                    onChange={(selected) => { setType(selected); }}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="forme" className="mb-1">Forme Juridique</label>
                                                <Select
                                                    id="forme"
                                                    name="forme"
                                                    options={formelist}
                                                    value={forme}
                                                    onChange={(selected) => { setforme(selected); }}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="noms" className="mb-1">Nom du client</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="noms">
                                                        <Person />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le nom"
                                                        aria-label="Nom client"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="abrev" className="mb-1">Abréviation du client</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="abrev">
                                                        <Person />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez l'abréviation"
                                                        aria-label="Abreviation client"
                                                        value={abrev}
                                                        onChange={(e) => setAbrev(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="adresse" className="mb-1">Adresse</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="adresse">
                                                        <PinMap />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez l'adresse du client "
                                                        aria-label="Adresse client"
                                                        value={adresse}
                                                        onChange={(e) => setAdresse(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="email" className="mb-1">Adresse Email</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="email">
                                                        <Envelope />
                                                    </span>
                                                    <input type="email"
                                                        className="form-control"
                                                        placeholder="Entrez l'adresse email"
                                                        aria-label="Email client"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="tel1" className="mb-1">Telephone N° 1</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="tel1">
                                                        <Phone />
                                                    </span>
                                                    <input type="tel"
                                                        className="form-control"
                                                        placeholder="Ex: 690000000"
                                                        aria-label="Numéro client"
                                                        value={tel1}
                                                        onChange={(e) => setTel1(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="tel2" className="mb-1">Telephone N° 2</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="tel2">
                                                        <Phone />
                                                    </span>
                                                    <input type="tel"
                                                        className="form-control"
                                                        placeholder="Ex: 690000000"
                                                        aria-label="Numéro client"
                                                        value={tel2}
                                                        onChange={(e) => setTel2(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label htmlFor="desc" className="mb-1">Description</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="desc">
                                                        <TextParagraph />
                                                    </span>
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Entrez la description du client"
                                                        value={desc}
                                                        onChange={(e) => setDesc(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <button type="submit"
                                            title="Valider l'ajout"
                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            disabled={name && email && tel1 && adresse && type["value"] ? false : true}
                                        >
                                            <i className="fa fa-check mr-2"></i>
                                            <span>Valider</span> {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}